module.exports = __webpack_public_path__ + "img/ltkbeauty-2x.cb55028.jpg";